import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import { renderToString } from 'react-dom/server';

export function FancyboxButtonShare() {
  return (
    <button data-fancybox-share="" className="fancybox-button fancybox-button--share" title="Share">
      <span className="fancybox-button__content">
        <FontAwesomeIcon icon={['fas', 'share']} />
        <span className="fancybox-button__label">{i18n.translate('share.button')}</span>
      </span>
    </button>
  );
}

export function getFancyboxButtonShareTpl(): string {
  return renderToString(<FancyboxButtonShare />);
}
